import cloneDeep from 'lodash/cloneDeep';
import { transformComponentByType, getCustomPluginJson } from '@whalecloud/page-builder-core/utils/util';
import { updateChildPaths } from '@whalecloud/page-builder-core/utils/elementUtils';
import { editorPlugins as customEditorPlugins } from '../index';

/**
 * 根据XML获取对象例Json
 * @param formXml
 * @param xmlPata
 */
export const getJsonByXml = (xml_str) => {
  const entities = xml_str(`Object`).toArray().map((v: any) => {
    const $entity = xml_str(v);
    const entity = { ...$entity.attr() };
    const fields = $entity.children('Field').toArray().map((ele: any) => {
      const filed = xml_str(ele).attr();
      const $options = xml_str(ele).children('Options').toArray();
      if ($options.length > 0) {
        const options = xml_str(ele).children('Options').toArray().map((opts: any) => {
          const refId = xml_str(opts).attr("ref-id");
          const $options = xml_str(`Collection`).children(`Options[id=${refId}]`);
          // 更具Options类型 转化value类型
          const optionsType = $options.attr('type');
          const option = $options.children('Option').toArray().map((opt: any) => {
            const newOpt = cloneDeep(xml_str(opt).attr());
            if (optionsType && optionsType === 'Integer') {
              newOpt.value = parseInt(newOpt.value);
            }
            return newOpt;
          });
          return option;
        });
        filed.options = options[0];
      }
      return filed;
    });
    entity.fields = fields;
    return entity;
  });
  return entities;
}

/**
 * 外部接口 根据xmlJSon 转化成FromJson
 */
export const getRenderFormJson = (xml_json) => {
  const pluginsData = [];
  // 注册edit 插件数据
  customEditorPlugins.forEach(element => {
    let ele = element();
    if (ele.name !== 'table' && ele.name !== 'card' && ele.name !== 'collapse' && ele.name !== 'tableEdit' && ele.name !== 'tabs') {
      ele = getCustomPluginJson(ele);
      pluginsData.push(ele);
    } 
  });

  // editorPlugins.forEach(element => {
  //   const ele = element.create();
  //   pluginsData.push(ele);
  // });
  const documentEle = {
    "type": "document",
    "elements": [
        {
            "id": "hV2lLVw6$8", 
            "data": {
                "formSettings": {
                    "layout": "horizontal", 
                    "colon": true, 
                    "labelAlign": "right", 
                    "labelWidth": 100, 
                    "name": "form_hV2lLVw6$8"
                }, 
                "settings": {
                    "width": {
                        "value": "100%"
                    }, 
                    "margin": {
                        "mobile": {
                            "top": 15, 
                            "left": 15, 
                            "right": 15, 
                            "bottom": 15
                        }, 
                        "desktop": {
                            "top": 25, 
                            "left": 0, 
                            "right": 0, 
                            "bottom": 25
                        }, 
                        "advanced": true
                    }, 
                    "padding": {
                        "mobile": {
                            "all": 10
                        }, 
                        "desktop": {
                            "all": 0
                        }
                    }
                }
            }, 
            "elements": [
                {
                    "id": "DnIb723ulI", 
                    "data": {
                        "settings": {
                            "margin": {}, 
                            "padding": {}
                        }
                    }, 
                    "elements": [
                        {
                            "id": "GmBEByuH24", 
                            "data": {
                              "settings": {
                                
                              }
                            }, 
                            "elements": [], 
                            "path": "0.0.0.0", 
                            "type": "column"
                        }
                    ], 
                    "path": "0.0.0", 
                    "type": "row"
                }
            ], 
            "path": "0.0", 
            "type": "form"
        }
    ], 
    "id": "FokAp8kEcn", 
    "path": "0", 
    "css": ""
  };

  const formElements = [];
  xml_json?.fields.forEach((el, index) => {
    const findItem = pluginsData.find((item) => {
      return item.type === transformComponentByType(el.type);
    });
    if (findItem) {
      const newItem = cloneDeep(findItem);
      newItem.data.formSettings.name = el.name;
      newItem.data.formSettings.label = el.label ? el.label : el.name;
      if (el.options && el.options.length > 0) {
        const formItemSettings = { 
          formItemSettings: {
            options: el.options,
            staticOptions: el.options,
          }
        }
        newItem.data = { ...newItem.data, ...formItemSettings };
      }
      formElements.push(newItem);
    }
  });

  documentEle.elements[0].elements = formElements;
  updateChildPaths(documentEle);
  return documentEle;
};

/**
 * 外部接口 设置from表单属性
 */
export const setFormItemAttr = (formItemJson, attrs) => {
  //document>> form>>row>>column
  const formItem = formItemJson.elements[0].elements;
  const newFormItem = formItem.map((vl: any) => {
    const item = vl;
    if (item.type !== "column") {
      const name = item.data.formSettings.name;
      const attr = attrs[name];
      return setItemAttr(item, attr)
    } else {
      const elementList = [];
      item.elements.forEach((child) => {
        const name = child.data.formSettings.name;
        const attr = attrs[name];
        elementList.push(setItemAttr(child, attr));
      });
      return { ...item, ...{ elements: elementList } };
    }
  });
  formItemJson.elements[0].elements = newFormItem;
  return formItemJson;
}

const setItemAttr = (item, attr) => {
  if (attr) {
    // items.data.settings.visible 显示隐藏
    const settings = { visible: 'visible', includeInLayout: 'true' };
    if (attr.visable && attr.visable === 'true') {
      item.data.settings = { ...item.data.settings, ...settings };
    } else if (attr.visable && attr.visable === 'false') {
      settings.visible = 'hidden';
      // 控制隐藏的dom是否占位
      if (attr.includeInLayout && attr.includeInLayout === 'false') {
        settings.includeInLayout = 'false';
      }
      item.data.settings = { ...item.data.settings, ...settings };
    }
    //readonly true 只读 disabled
    if (attr.readonly && attr.readonly === 'true') {
      item.data.formItemSettings = { ...item.data.formItemSettings, ...{ disabled: true } };
    }
    
    //items.data.formSettings.rules 是否必填 nullable
    if (!(attr.nullable && attr.nullable === 'true')) {
      const rules = [];
      rules.push({
        required: true,
        message: '这是必填项。'
      });
      item.data.formSettings = { ...item.data.formSettings, ...{ rules: rules } };
    }
  }
  return item;
}

/**
 * 将业务参数与元素默认参数合并
 * @param data
 * @param key
 * @param value
 */
const mergeAttrs = (data, key, value) => {
  let addFlag = false;
  const { settings, formSettings, formItemSettings, tableSettings, columnSettings, componentSettings } = data;
  if (settings && Object.prototype.hasOwnProperty.call(settings, key)) {
    settings[key] = value;
    addFlag = true;
  }
  if (formSettings && Object.prototype.hasOwnProperty.call(formSettings, key)) {
    formSettings[key] = value;
    addFlag = true;
  }
  if (formItemSettings && Object.prototype.hasOwnProperty.call(formItemSettings, key)) {
    formItemSettings[key] = value;
    addFlag = true;
  }
  if (tableSettings && Object.prototype.hasOwnProperty.call(tableSettings, key)) {
    tableSettings[key] = value;
    addFlag = true;
  }
  if (columnSettings && Object.prototype.hasOwnProperty.call(columnSettings, key)) {
    columnSettings[key] = value;
    addFlag = true;
  }
  if (componentSettings && Object.prototype.hasOwnProperty.call(componentSettings, key)) {
    componentSettings[key] = value;
    addFlag = true;
  }
  if (!addFlag) {
    if (formItemSettings) {
      formItemSettings[key] = value;
    } else if (tableSettings) {
      tableSettings[key] = value;
    } else if (columnSettings) {
      columnSettings[key] = value;
    } else if (componentSettings) {
      componentSettings[key] = value;
    }
  }
}

/**
 * 为form添加Field Array [{name: "state" id: "02271c61-0e41-4edb-8092-a3b196c8d95e" code: "STATE" label: "state" type: "Picklist" nullable: "false" visable: "true" readonly: "false" length: "128"}]
 * @param formItemJson
 * @param field
 */
export const addFormField = (formItemJson, fields) => {
  const pluginsData = [];
  // 注册edit 插件数据
  customEditorPlugins.forEach(element => {
    let ele = element();
    if (ele.name !== 'table' && ele.name !== 'card' && ele.name !== 'collapse' && ele.name !== 'tableEdit' && ele.name !== 'tabs') {
      ele = getCustomPluginJson(ele);
      pluginsData.push(ele);
    }
  });
  const newFormItem = formItemJson.elements[0].elements;
  if (fields) {
    fields.forEach((el, index) => {
      const findItem = pluginsData.find((item) => {
        return item.type === transformComponentByType(el.type);
      });
      if (findItem) {
        const newItem = cloneDeep(findItem);
        const { data = {} } = newItem;
        Object.keys(el).forEach(key => {
          const value = el[key];
          mergeAttrs(data, key, value);
        })
        newItem.data.formSettings.name = el.name;
        newItem.data.formSettings.label = el.label ? el.label : el.name;

        if (el.options && el.options.length > 0) {
          const formItemSettings = {
            formItemSettings: {
              options: el.options,
              staticOptions: el.options,
            }
          }
          newItem.data = { ...newItem.data, ...formItemSettings };
        }
        newFormItem.push(newItem);
      }
    });
  }
  formItemJson.elements[0].elements = newFormItem;
  return formItemJson;
}
